module.exports = __webpack_public_path__ + "img/baidu.9f6c3aa1.jpg";